<template>
  <v-container fluid class="px-0">
    <v-alert
      colored-border
      dense
      border="left"
      color="blue"
      class="bg-notif mb-0 body-2"
      v-if="withAction && type !== 'dokumen'"
    >
      <v-row no-gutters align="center">
        <template>
          <template v-if="!items.length">
            <v-col class="grow"> Tambahkan Data <span v-html="subtitle || title"></span></v-col>
            <v-col class="shrink">
              <v-btn right depressed small color="info" dark @click="onEdit(type)">
                <v-icon small v-text="'mdi-plus-box-outline'"></v-icon> Tambah
              </v-btn>
            </v-col>
          </template>
          <template v-else>
            <v-col class="grow"> Data <span v-html="subtitle || title"></span></v-col>
            <v-col class="shrink">
              <v-btn right depressed small color="blue" dark @click="onEdit(type)">
                <v-icon small v-text="'mdi-pencil'"></v-icon> Ubah
              </v-btn>
            </v-col>
          </template>
        </template>
      </v-row>
    </v-alert>
    <v-list>
      <template v-if="!items.length">
        <em class="grey--text">Tidak ada data ditemukan</em>
      </template>
      <template v-if="type !== 'dokumen'">
        <v-list-item v-for="(item, i) in items" :key="i" class="pa-0">
          <div style="width: 100%">
            <collection :role="role" :type="type" :data="item" :program="program" :masters="masters"></collection>
            <v-divider v-if="(items || []).length > 1 && (items || []).length - 1 !== Number(i)"></v-divider>
          </div>
        </v-list-item>
      </template>
      <template v-else>
        <template v-for="(item, i) in items">
          <div :key="item.id">
            <collection-berkases
              :key="item.id"
              :ref="`tab-${item.id}`"
              :type="item.id"
              :optional="item.optional"
              :valid="isUpload(item.id)"
              :berkas="item || {}"
              :value="getBerkas(item.id)"
              :withAction="withAction"
              @upload="onUpload(item.id)"
            ></collection-berkases>
            <v-divider v-if="items.length - i !== 1"></v-divider>
          </div>
        </template>
      </template>
    </v-list>
  </v-container>
</template>

<script>
import Collection from '../component/Collection';
import CollectionBerkases from '../component/CollectionBerkases';

export default {
  name: 'CvDaftar',
  components: { Collection, CollectionBerkases },
  props: {
    role: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    berkases: {
      type: Array,
      default: () => [],
    },
    program: {
      type: String,
      default: 'ppg',
    },
    withAction: {
      type: Boolean,
      default: false,
    },
    component: {
      type: String,
      default: '',
    },
    masters: {
      type: Object,
      default: () => {},
    },
    profil: {
      type: Object,
      default: () => {},
    },
    isPA: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isUpload(id) {
      if (!this.isPA && id === 'pakta') {
        return !!this.$getDeepObj(this, 'profil.meta.peserta_ajuan.url_pakta');
      }

      return (
        this.berkases.filter((item) => {
          if (
            id === 'rekomendasi' &&
            ['ref_atasan', 'ref_teman', 'ref_komunitas'].indexOf(
              this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat')
            ) > -1
          ) {
            return true;
          } else {
            return this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat') === id;
          }
        }).length > 0
      );
    },
    getBerkas(id) {
      if (!this.isPA && id === 'pakta') {
        const ajuan = this.$getDeepObj(this, 'profil.meta.peserta_ajuan') || {};
        return ajuan.url_pakta
          ? {
              file_berkas: this.$getDeepObj(ajuan, 'file_pakta'),
              url_berkas: this.$getDeepObj(ajuan, 'url_pakta'),
            }
          : {};
      }

      const berkas = this.berkases.filter((item) => {
        if (id === 'rekomendasi') {
          if (this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat') === 'ref_atasan') {
            return this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat') === 'ref_atasan';
          } else if (this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat') === 'ref_teman') {
            return this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat') === 'ref_teman';
          } else if (this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat') === 'ref_komunitas') {
            return this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat') === 'ref_komunitas';
          } else {
            return this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat') === id;
          }
        } else {
          return this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat') === id;
        }
      });

      return (berkas && berkas[0]) || {};
    },
    onAction(arg) {
      this[arg.event && arg.event.event](arg.data, arg.id);
    },
    onEdit(data, id) {
      this.$emit('edit', Object.assign({}, data, { type: this.type, id }));
    },
    onUpload(type) {
      this.$emit('upload', { type: type });
    },
    allow(action) {
      let disabled = false;
      switch (action.event) {
        default:
          disabled = false;
          break;
      }
      return !disabled;
    },
  },
};
</script>

<style scoped>
.bg-notif {
  background-color: rgb(187, 222, 251) !important;
}
</style>
